const randomize = require("randomatic");

export default [
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/TextFilter"),
    props: {
      filterName: "flightNo_contains",
      label: "Flight No",
      filterValue: null,
    },
  },
  {
    id: randomize("Aa0", 32),
    component: () => import("../../shared/list-filters/BooleanFilter"),
    props: {
      filterName: "isException",
      label: "Is Exception",
      filterValue: false,
    },
  },
];



// WEBPACK FOOTER //
// ./src/components/gt/plugins/flights/list-filters.js